// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-target {
  margin: 2rem 0;
}

.board-target {
  margin: 0 0 2rem 0;
}

.switch-target {
  button {
    margin-right: 0.25rem;
  }
}

.list-target {
  .btn-station {
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 0.5rem;
  }

  .btn-station.transfer {
    padding-left: 0.75rem;
    color: var(--dot-on);
  }

  .btn-station.terminus {
    padding-left: 0.75rem;
  }

  .station-icons {
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 0.25rem;
  }
}

.station-label {
  margin: 1rem 0;
  font-size: 1.5rem;
  text-transform: uppercase;
  align-self: flex-end;
}

@media screen and (max-width: 668px) {
  .board-target {
    margin: 0 0 0.5rem 0;
  }

  .station-label {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/stations.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".content-target {\n  margin: 2rem 0;\n}\n\n.board-target {\n  margin: 0 0 2rem 0;\n}\n\n.switch-target {\n  button {\n    margin-right: 0.25rem;\n  }\n}\n\n.list-target {\n  .btn-station {\n    display: flex;\n    flex-flow: row;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  .btn-station.transfer {\n    padding-left: 0.75rem;\n    color: var(--dot-on);\n  }\n\n  .btn-station.terminus {\n    padding-left: 0.75rem;\n  }\n\n  .station-icons {\n    display: flex;\n    flex-flow: row;\n    align-items: center;\n    gap: 0.25rem;\n  }\n}\n\n.station-label {\n  margin: 1rem 0;\n  font-size: 1.5rem;\n  text-transform: uppercase;\n  align-self: flex-end;\n}\n\n@media screen and (max-width: 668px) {\n  .board-target {\n    margin: 0 0 0.5rem 0;\n  }\n\n  .station-label {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
